<template functional>
  <div class="cart">
    <div class="level header is-mobile">
      <div class="level-left header-title">
        <slot name="header-title" :label="props.headerLabel">
          {{ props.headerLabel }}
        </slot>
      </div>
      <div class="level-right header-close">
        <slot name="close-button" />
      </div>
    </div>
    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: 'Cart',
  props: {
    headerLabel: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.header {
  background-color: $grey-light;
  padding: 8px 17px 6px;
  text-transform: uppercase;
  &.level {
    margin: 0;
  }
}

.header-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 18px;
}

.header-close {
  font-size: 24px;
  font-weight: 600;
  line-height: 18px;
}

/deep/ .close {
  padding: 0;
  border: 0;
  height: 24px;
  font-size: 24px;
}
</style>
